import { useNavigate } from 'react-router-dom';
import { NavigationService } from 'services/navigation.service';

interface BreadcrumbProps {
  links: { label: string, route: string, icon?: React.SVGProps<SVGSVGElement> }[];
  needConfirmationToNav: boolean;
};

export const Breadcrumb = ( { links, needConfirmationToNav }: BreadcrumbProps ) => {

  const navigate = useNavigate();

  return (
    <div className="flex h-fit w-full gap-2 px-4 py-2 shadow-inner">
      {
        links.map( ( link, index ) => {
          return (
            <div
              key={link.route}
              className='flex gap-2 select-none'
            >
              <span
                className={
                  'flex items-center justify-center text-center gap-1 font-medium hover:text-gray-600 hover:fill-gray-600 ' +
                  ( index === ( links.length - 1 ) ? 'text-gray-600 fill-gray-600 underline underline-offset-2' : 'text-gray-400 fill-gray-400 cursor-pointer' )
                }
                onClick={ () => { if ( index !== ( links.length - 1 ) ) { NavigationService.navigateTo( link.route, needConfirmationToNav, navigate ); } } }
              >
                {
                  link.icon ?
                    <div> { link.icon as JSX.Element } </div>
                    :
                    null
                }
                { link.label }
              </span>
              <span className='text-gray-400'>
                { ( index === ( links.length - 1 ) ? '' : '/' ) }
              </span>
            </div>
          );
        } )
      }
    </div>
  );
};